module.exports = __webpack_public_path__ + "img/antes_despues_78.6b949779.png";